import { render, staticRenderFns } from "./STFloatingFooter.vue?vue&type=template&id=7d8ff7db"
var script = {}
import style0 from "./STFloatingFooter.vue?vue&type=style&index=0&id=7d8ff7db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports